import styled from 'styled-components';
import {injectSafeLeft, injectSafeRight} from 'ui/theme';

export const Container = styled.div`
  padding: 5px 20px;
  ${injectSafeLeft('margin')}
  ${injectSafeRight('margin')}
`;

export const SectionBorderConcealer = styled.div`
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    display: block;
    height: 2px;
    background: ${(p) => p.theme.dark};
    content: ' ';
  }
`;
